import { Loader, Pencil, Trash2 } from "lucide-react";
import { Button } from "src/components/ui/button";
import { Input } from "src/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";
import { PricesData } from "../../../../../lib/languages";
import { useLanguage } from "../../../../../context/LanguageContext";

export default function FeaturesDialog({
  isFeatureDialogOpen,
  setIsFeatureDialogOpen,
  selectedPrice,
  btnLoading,
  newFeature,
  setNewFeature,
  handleUpdateFeature,
  handleAddFeature,
  setEditingFeature,
  handleDeleteFeature,
  resetForm,
  editingFeature,
  errors,
}) {
  const { language } = useLanguage();
  const strings = PricesData[language] || PricesData["en"];

  return (
    <Dialog open={isFeatureDialogOpen} onOpenChange={setIsFeatureDialogOpen}>
      <DialogContent
        className="sm:max-w-[500px] overflow-auto max-h-[90vh]"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <DialogHeader>
          <DialogTitle>{strings.manageFeatures}</DialogTitle>
          <DialogDescription>
            {selectedPrice && strings.manageFeaturesDesc(selectedPrice.name)}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div>
            <div className="flex items-center gap-2">
              <Input
                placeholder="Add a new feature..."
                value={newFeature}
                onChange={(e) => setNewFeature(e.target.value)}
              />
              <Button
                onClick={
                  editingFeature ? handleUpdateFeature : handleAddFeature
                }
                disabled={btnLoading.feature || !newFeature}
              >
                {btnLoading.feature ? (
                  <Loader className="animate-spin h-4 w-4" />
                ) : editingFeature ? (
                  strings.update
                ) : (
                  strings.add
                )}
              </Button>
            </div>
            {errors?.description && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.description[0]}
              </p>
            )}
          </div>

          {selectedPrice && selectedPrice.price_feature.length > 0 ? (
            <div className="border rounded-md overflow-hidden">
              <table className="w-full border-collapse">
                <thead>
                  <tr>
                    <th className="px-4 py-2 text-start text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {strings.featuresLabel.replace(":", "")}
                    </th>
                    <th className="px-4 py-2 text-start text-xs font-medium text-gray-500 uppercase tracking-wider w-[100px]">
                      {strings.actions}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {selectedPrice.price_feature.map((feature) => (
                    <tr key={feature.id} className="hover:bg-muted">
                      <td className="px-4 py-3 text-sm">
                        {feature.description}
                      </td>
                      <td className="px-4 py-3 text-right">
                        <div className="flex items-center justify-end space-x-2">
                          <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => {
                              setEditingFeature(feature);
                              setNewFeature(feature.description);
                            }}
                          >
                            <Pencil className="h-4 w-4" />
                          </Button>
                          <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => handleDeleteFeature(feature.id)}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4 text-muted-foreground">
              {language === "en"
                ? "No features added yet. Add your first feature above."
                : "لم تتم إضافة ميزات بعد. أضف ميزتك الأولى أعلاه."}
            </div>
          )}
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              setIsFeatureDialogOpen(false);
              resetForm();
              setNewFeature("");
              setEditingFeature(null);
            }}
          >
            {strings.cancel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
